export enum RecordingState {
    Pending = 'Pending',
    Stopped = 'Stopped',
    Starting = 'Starting',
    Recording = 'Recording',
    Uploading = 'Uploading',
}